import RemoteSelect, {
  RemoteSelectProps,
} from "common/components/RemoteSelect/RemoteSelect";
import RemoteSelectWithFilters from "common/components/RemoteSelect/RemoteSelectWithFilters";
import usePark from "common/hooks/usePark";
import { ObservationGroup } from "types/ObservationGroup";

export type ObservationGroupSelectProps = {
  additionalFilters?: {
    name: string;
    key: string;
    component: React.ReactNode;
  }[];
} & RemoteSelectProps;

const processOptions = (options: ObservationGroup[]) =>
  options.map(({ id, name }) => ({
    value: id,
    label: name,
  }));

function ObservationGroupSelect({
  additionalFilters,
  ...props
}: ObservationGroupSelectProps) {
  const { park } = usePark();

  return additionalFilters && additionalFilters.length > 0 ? (
    <RemoteSelectWithFilters
      url="observation-groups"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      filtersComponents={additionalFilters}
      shouldRenderValue
      clearable={false}
      {...props}
    />
  ) : (
    <RemoteSelect
      url="observation-groups"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      {...props}
    />
  );
}

export default ObservationGroupSelect;
